import AccountDetails from '@advisor/models/store/accountDetails';
import RwClientService from '@advisor/rwSdk/ClientService';
import exceptionHandler from '@advisor/util/exceptionHandler';
import AccountSummary from '@advisor/models/store/accountDetails/AccountSummary';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';

export const stateObj = function () {
  return new AccountDetails();
};

export const getters = {
  accountSummary: (state) => state.account,
};

export const actions = {
  async getAccountDetails({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwClientService.getAccountDetails(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_ACCOUNT_SUMMARY_DETAILS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('accountDetails.getAccountDetails', error);

      return Promise.reject(error);
    }
  },

  async getClientSpecificInfo({commit}, payload) {
    try {
      const {id, include} = payload;
      const options = {clUserId: id, include: [include]};

      const sdkResponse = await RwClientService.getClUserDetails(options).catch((error) => {
        throw error;
      });

      return commit('SET_CLIENT_SPECIFIC_INFO', sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('accountDetails.getClientSpecificInfo', error);

      return Promise.reject(error);
    }
  },

  setRoboStatus({commit}, payload) {
    try {
      commit('SET_ROBO_STATUS', payload);

      return Promise.resolve(payload);
    } catch (error) {
      exceptionHandler.handleGenericException('accountDetails.setRoboStatus', error);

      return Promise.reject(error);
    }
  },
};

export const mutations = {
  /**
   *
   * @param {Object} state
   * @param {Array} payload
   */
  SET_ACCOUNT_SUMMARY_DETAILS(state, payload) {
    state.account = new AccountSummary();
    state.roboStatus = 0;

    if (Array.isArray(payload) && payload.length > 0) {
      const value = payload[0];

      state.account = {
        ...state.account,
        ...value,
        dividendSetting: value.dividend_setting,
      };

      state.roboStatus = value.robo_on_off ? value.robo_on_off : 0;
    }
  },
  SET_CLIENT_SPECIFIC_INFO(state, payload) {
    state.clientDetails = payload;
  },
  SET_ROBO_STATUS(state, payload) {
    state.roboStatus = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
